import {
  Input as ChakraInput,
  InputGroup,
  InputLeftAddon,
} from '@chakra-ui/react'
import { forwardRef } from 'react'

export const Input = forwardRef(({ label, onChange, ...props }, ref) => {
  return (
    <InputGroup>
      <InputLeftAddon fontSize="12px" color="#378BBF" fontWeight="bold">
        {label}
      </InputLeftAddon>
      <ChakraInput
        borderRadius={0}
        borderColor="#378BBF"
        _focus={{ filter: 'brightness(.9)' }}
        _hover={{ filter: 'brightness(1.1)' }}
        {...props}
        ref={ref}
      />
    </InputGroup>
  )
})
